import React from "react";
import { IconButton, makeStyles, Tooltip } from "@material-ui/core";
import { Delete, Edit, FileCopy, SaveAlt } from "@material-ui/icons";
import ImportIcon from "@material-ui/icons/CloudUpload";
import { itemType } from "../ExplorerTree/ExplorerTree";
import LoadingOverlay from "components/LoadingOverlay/LoadingOverlay";

const useStyles = makeStyles({
  root: {
    display: "flex",
    width: "100%",
    paddingBottom: 10
  },
  grow: {
    flexGrow: 1
  },
  iconButton: {
    padding: 5
  }
});

/**
 * A component that can host buttons to perform operations in the selected item from the Tree
 * @author Akira Kotsugai
 * @param {Object} props - object is expected to have callback functions for exporting, editing and deleting items
 * @return {Component} a delete button
 */
const ExplorerPanel = ({
  selectedItem,
  onExport,
  onEdit,
  onDelete,
  onImport,
  isLoading,
  onCopy
}) => {
  const classes = useStyles();
  const handleImportClick = () => {
    onImport();
  };
  return (
    <div className={classes.root} test-data="explorerPanel">
      <div className={classes.grow} />
      {isLoading && <LoadingOverlay />}
      <Tooltip title="Import" placement="top">
        <IconButton
          test-data="importBtn"
          name="TreeImportButton"
          className={classes.iconButton}
          onClick={handleImportClick}
          disabled={Array.isArray(selectedItem)}
        >
          <ImportIcon fontSize="small" />
        </IconButton>
      </Tooltip>

      <Tooltip title="Export" placement="top">
        <div>
          <IconButton
            test-data="exportBtn"
            name="TreeExportButton"
            className={classes.iconButton}
            onClick={onExport}
            disabled={
              !selectedItem ||
              Array.isArray(selectedItem) ||
              selectedItem.type !== itemType.SIMULATION ||
              !selectedItem.id
            }
          >
            <SaveAlt fontSize="small" />
          </IconButton>
        </div>
      </Tooltip>
      <Tooltip title="Duplicate" placement="top">
        <div>
          <IconButton
            name="TreeDuplicateButton"
            test-data="copyBtn"
            className={classes.iconButton}
            onClick={onCopy}
            disabled={
              !selectedItem ||
              Array.isArray(selectedItem) ||
              selectedItem.type !== itemType.SIMULATION ||
              !selectedItem.id
            }
          >
            <FileCopy fontSize="small" />
          </IconButton>
        </div>
      </Tooltip>
      <Tooltip title="Rename" placement="top">
        <div>
          <IconButton
            name="TreeEditButton"
            test-data="editBtn"
            className={classes.iconButton}
            onClick={onEdit}
            disabled={
              !selectedItem ||
              !selectedItem.id ||
              Array.isArray(selectedItem) ||
              selectedItem.type === "user"
            }
          >
            <Edit fontSize="small" />
          </IconButton>
        </div>
      </Tooltip>
      <Tooltip title="Delete" placement="top">
        <div>
          <IconButton
            test-data="deleteBtn"
            name="TreeDeleteButton"
            className={classes.iconButton}
            onClick={onDelete}
            disabled={
              !selectedItem ||
              (!Array.isArray(selectedItem) && !selectedItem.id) ||
              selectedItem.type === "user"
            }
          >
            <Delete fontSize="small" />
          </IconButton>
        </div>
      </Tooltip>
    </div>
  );
};

export default ExplorerPanel;
